<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" epub:type="chapter" id="unnumbered-1" role="doc-chapter">
<div class="heading heading-container-single heading-size-full heading-format-full heading-alignment-flexible heading-without-image">
<div class="heading-contents">
<div class="title-subtitle-block title-block-without-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="element-title case-mixed">One year earlier</h1>
</div>
</div>
</div>
</div>
<div class="text" id="unnumbered-1-text">
<p class="first first-in-chapter first-full-width first-with-first-letter-s"><i><span class="drop-cap">S</span>he sat in her usual chair in the therapist’s room, her hands clasped together, her shoulders hunched.</i></p>
<p class="subsq"><i>‘Do you want to talk about the birth?’ Leah asked, handing her a mug of coffee.</i></p>
<p class="subsq"><i>No, I don’t want to talk about the birth, she thought. The rain splashed at the windows and her eyesight blurred.</i></p>
<p class="subsq"><i>‘I don’t really remember much,’ she said. It didn’t sound like her voice. It was too far away. ‘I know it was raining. I remember hailstones hitting the windows. I was excited that it was happening.’</i></p>
<p class="subsq"><i>She squeezed her hands tightly, the nails sharp and painful in her palms.</i></p>
<p class="subsq"><i>‘I remember thinking it doesn’t matter about the pain. It would all be worth it, and it was.’</i></p>
<p class="subsq"><i>‘It’s a good memory?’</i></p>
<p class="subsq"><i>She nodded.</i></p>
<p class="subsq"><i>‘But I wanted three. I always wanted three. I’d planned that we’d have the second a year later. That way they could grow up together …’</i></p>
<p class="subsq"><i>Her throat seemed to close up and she struggled to breathe.</i></p>
<p class="subsq"><i>‘Do you need a glass of water?’ Leah asked kindly.</i></p>
<p class="subsq"><i>She shook her head. All she seemed to do here was drink endless amounts of water.</i></p>
<p class="subsq"><i>‘I still can’t accept it. I do try. I remember the pain, it went on for hours. I would have liked a natural birth but I was relieved when I was taken to the operating theatre. Everyone said I should be grateful to have a baby but I only felt disappointment and anger. It was my mother who told me that I couldn’t have any more’.</i></p>
<p class="subsq"><i>‘Are you still angry with the doctors for taking away your womb?’</i></p>
<p class="subsq"><i>She shrugged. Her hand trembled and she carefully placed the mug of coffee on to the table next to a solitary box of tissues. She found herself wondering how often Leah replaces the box. Every day? Every few hours?</i></p>
<p class="subsq"><i>‘You need to get past this if we’re to move on. You have to accept.’</i></p>
<p class="subsq"><i>It’s easy for her to say, she thought angrily.</i></p>
<p class="subsq"><i>‘Do you have a family?’ she asked.</i></p>
<p class="subsq"><i>‘It’s not about me,’ said Leah</i></p>
<p class="subsq"><i>‘I have to go,’ she said suddenly, standing up.</i></p>
<p class="subsq"><i>Leah didn’t seem surprised.</i></p>
<p class="subsq"><i>At least she’d stayed longer than last time.</i></p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// one-year-earlier.vue?043425ba